import moment from 'moment';
import { JSXElementConstructor, ReactElement } from 'react';

declare global {
  interface StringConstructor {
    formatUnicorn(): string;
  }
}

if(!String.formatUnicorn) {
String.formatUnicorn = 
function () {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
        var t = typeof arguments[0];
        var key;
        var args = ("string" === t || "number" === t) ?
            Array.prototype.slice.call(arguments)
            : arguments[0];

        for (key in args) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
        }
    }

    return str;
};
}

class DateHelperClass {
    getDate = (val, format = 'DD-MM-YYYY') => {
        let retVal = moment(val).format(format);
        return retVal;
        }

        getCurrent =(format = "ms", val = null): string | number | moment.Moment | ReactElement<any, string | JSXElementConstructor<any>> => {
            
            let retVal = (val) ? moment(val) : moment();
            
            if(format == "ms" ) {
                return retVal.valueOf();
            } else if(format == "") {
                return retVal;
            }
            console.debug( retVal.format(format) );
            return retVal.format(format);
        }

        getHourMinutes = (val) => {
            let retVal = "";
            let hours = 0;
            let minutes = 0;
            
            if(val >= 60) {
                hours = Math.floor(val / 60);
                minutes = val - (hours*60);
                
            } else if(val > 0) {
                minutes = val;
            }
            
            return [hours, minutes];
        }
                
        getTimeStrFromMinutes = (val) => {
            let retVal = "";
            let hours = 0;
            let minutes = 0;
            
            if(val >= 60) {
                hours = Math.floor(val / 60);
                minutes = val - (hours*60);
                
            } else if(val > 0) {
                minutes = val;
            }
            let hoursStr  = "00"+hours;
            let minutesStr = "00"+minutes;
            
            retVal = (hoursStr).slice(-2)+":"+ minutesStr.slice(-2);
            return retVal;
            
            }
        getTotalminutesFromStr = (val) => {
                let retVal = 0;
            if(val) {
                let timeArray = val.split(':');
                if(timeArray.length == 1) {
                    timeArray.push(0)
                }
                retVal = this.getTotalminutes(timeArray[0], timeArray[1]);
            }
            
            return retVal as Number;
    }
    
    getTotalminutes = (hour, minutes) => {
        let totalMinutes = 0;
         if(parseInt(hour) > 0) {
            totalMinutes += parseInt(hour)  * 60;
        }
        if( parseInt(minutes) > 0) {
            totalMinutes += parseInt(minutes);
//            let hourMinutes = Math.floor(parseInt(minutes) / 60);
//            let totalHour = hourMinutes * 60;
            
//            totalMinutes += (parseInt(minutes) - totalHour) + totalHour;
        }
        
        return totalMinutes;
    }

    getAmountOfDays = (days, excludeWeekend = true) => {
        let retVal = days;
        let daysLeft = 0;
        const momentDate = moment().add('day', 0);
        let extraWeekend = (momentDate.day()+days) > 5;
        let totalWeeks = Math.floor( (days) / 5);
        if(extraWeekend) {
            totalWeeks = Math.floor( (days-2) / 5);
        }

        if(excludeWeekend && totalWeeks >= 1) {
            daysLeft = days - (totalWeeks * 5);
        } else {
            daysLeft = days
        }

        if(extraWeekend) {
            daysLeft = daysLeft + 2;
        }
        
        retVal = (totalWeeks*7) + daysLeft;
        
        return retVal;
        /*        
        if(excludeWeekend && days >= 5) {
             totalWeeks = Math.floor(days / 5);
             retVal = retVal - (totalWeeks * 5);
             //days = Math.abs(days - retVal);
        } else if(excludeWeekend && (momentDate.day() + retVal) > 5) {
            if(momentDate.day() + retVal == 6) {
                retVal += 2;
            } else {
                retVal += 1;
            }
        }
        */
        const newDate = momentDate.clone().add('day', retVal);
        
        console.debug("DAY NUMBER", newDate.day());
        
        
        console.debug("DAY NUMBER", momentDate.day());
        
        if(newDate.day() == 0) {
            //retVal += 1;
        } else if(newDate.day() == 6) {
            //retVal += 2;
        }
        
        return retVal ;
    }
    
    getTotalInHumanStr = (totMinutes, hoursInDay=8):object => {
        let retVal = {};
        const hoursminutes = this.getHourMinutes(totMinutes);
        let workDays = 0;
        let hours = hoursminutes[0];
        let minutes = hoursminutes[1];
        if(hours >= hoursInDay) {
            workDays = Math.floor( hours / hoursInDay );
            hours = hours - ( workDays * hoursInDay );
        }
        
            retVal['day'] = workDays; 
            retVal['hour'] = hours; 
            retVal['min'] = minutes;
            retVal['divider1'] = 0; 
            retVal['divider2'] = 0;
        if(workDays > 0 && hours > 0) {
            retVal['divider1'] = (minutes > 0) ? 2 : 1;
        }
        if(minutes > 0 && (workDays+hours) > 0) {
            retVal['divider2'] = (minutes > 0) ? 1 : 0;
        }
        
        
        return retVal;
      }
    
    
    getDaysInWeek = ():any => {
        let days = moment.weekdays(true);
        
        return days;
      }
    
    getDaysForMonth = (date) => {
        let t = moment.updateLocale('nl', {week : {dow:1,doy:1} });
        var now = moment(date).local();
        var startMonth  = moment(date).local().startOf('month');
        var endMonth  = moment(date).local().endOf('month');
        let startMonthDay = startMonth.day();
        if(startMonth.day() == 0) {
            startMonthDay = 7;
        }
        let startOfCalender = startMonth.clone().subtract(startMonthDay-1, 'days');
        let revVal = new Array();
        let totalDays = startMonth.daysInMonth() + (7-endMonth.day());
        let index = 0;
        for(let i = (1-startMonthDay); i <= 42-startMonthDay; i++) {
            let isCurrentMonth = true;
            if(i < 0) {
                isCurrentMonth = false;
            } else if(i >= startMonth.daysInMonth()) {
                isCurrentMonth = false;
            }
            revVal.push({key:"K_"+startOfCalender.format("YMMDD"), daykey:startOfCalender.format("YYYYMMDD"), year: startOfCalender.format("YYYY"), month: startOfCalender.format("MM"), weekDay: startOfCalender.weekday(),
            day:startOfCalender.format("DD"),date:startOfCalender.format("Y-M-D"), isCurrentMonth: isCurrentMonth, events: [], index: index});
            startOfCalender.add(1, 'day');
            
            index++;
        }
        
        return revVal;
    }
    
}

export default new DateHelperClass();